import React
    // ,  {useState, useEffect, useRef} 
    from 'react';
import {Navbar,Nav,Button,Container } from 'react-bootstrap';
import {Link} from 'gatsby';
import './header.css';

// const usePreviousValue = value => {
//     const ref = useRef();
//     useEffect(() => {
//       ref.current = value;
//     });
//     return ref.current;
//   };


const Header = () => {
    // const [value, setValue] =  useState(0)
    // const prevValue = usePreviousValue(value)
     
    // useEffect(() => {
    //     window.addEventListener("scroll", () => {
    //         setValue(window.pageYOffset);
    //     })
        
    // },[]);

    // if(prevValue > value) {
    //     console.log("Visible")
    // }else{
    //     console.log("hide")
    // }
  
    let page = '/';
    if (typeof window !== `undefined`) {
        page = window.location.pathname;
    }
    return (
        
        <Navbar 
        // sticky={prevValue > value && 'top'} 
         className="my-3"  expand="lg" className="navbar-dark">
            <Container fluid>
                <Navbar.Brand>
                    <Link to="/">
                        <h1 style={{color:"white"}}>S</h1>
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                
                <Navbar.Collapse  id="basic-navbar-nav">
                    <Nav className="ml-auto">
                        <Nav.Item as="li">
                            <Link to="/" className=
                            { 
                                page === '/' ? "nav-link active" : "nav-link"
                            }>Home</Link>
                        </Nav.Item>
                        <Nav.Item as="li">
                            <Link to="/about" className={ 
                                page === '/about' || page === '/about/' ? "nav-link active" : "nav-link"
                            }>About</Link>
                        </Nav.Item>
                        <Nav.Item as="li">
                            <Link to="/works" className={ 
                                page === '/works' || page === '/works/'  ? "nav-link active" : "nav-link"
                            }>Works</Link>
                        </Nav.Item>
                        <Nav.Item as="li">
                            <Link to="/blog" className={ 
                                page === '/blog' ||  page === '/blog/' ? "nav-link active" : "nav-link"
                            }>Blog</Link>
                        </Nav.Item>
                        <Nav.Item as="li">
                            <Link to="/contact" className={ 
                                page === '/contact' || page === '/contact/' ? "nav-link active" : "nav-link"
                            }>Contact</Link>
                        </Nav.Item>
                        <a target="_blank" rel="noreferrer" href="https://docs.google.com/document/d/1cWXkuL9T0yaM7B-NEZfMluiiVm6YEhWDtGETkqsx3Lk/edit?usp=sharing" className="text-white">
                            <Button variant="outline-success">Resume</Button>
                        </a>
                    </Nav>
                    
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;